// #213: how an exercise is LOGGED, read off its catalog row and nowhere else.
// Antenore, 17/10: «Tutte queste caratteristiche devono essere nel catalogo».
// The slug, its prefix and the name say nothing here: `assisted-pull-up` is
// assisted because its row says `assisted: true`, not because of its spelling.
//
// One default for an exercise with no catalog row (a deleted personal
// exercise, a catalog not loaded yet): neither bodyweight nor assisted. The
// logger's entry kind and the hold-load math used to disagree on it.

/** A catalog (or lookup) list the traits are read from, by slug. */
export type TraitsCatalog = ReadonlyArray<ExerciseTraitsRow & { slug: string }>;

/** The catalog fields this reads. Loose, so a lookup row or a full Exercise both fit. */
export type ExerciseTraitsRow = {
  isBodyweight?: boolean | null;
  assisted?: boolean | null;
};

export type ExerciseTraits = {
  /** Logs reps + an EXTRA over the bodyweight, not a weight. */
  isBodyweight: boolean;
  /** A new set with no weight to inherit starts with a negative extra. */
  isAssisted: boolean;
};

/**
 * `storedKind` is the LAST RESORT and only that: the kind a saved set was
 * stored with (`WorkoutSet.type` / `LogSet.kind`). It is read only when the
 * catalog has no row for the exercise, since a set saved as `bodyweight` is
 * then the one remaining evidence of how it was logged. With a row, the row
 * wins, even when an older saved set says otherwise.
 *
 * `preferStored` (reopening a saved session): a stored kind wins over the row,
 * because it is the recorded data. `isAssisted` still comes from the row.
 */
export const exerciseTraits = (
  row: ExerciseTraitsRow | null | undefined,
  storedKind?: string,
  opts: { preferStored?: boolean } = {},
): ExerciseTraits =>
  row && opts.preferStored && storedKind !== undefined
    ? { isBodyweight: storedKind === "bodyweight", isAssisted: row.assisted === true }
    : row
    ? { isBodyweight: row.isBodyweight === true, isAssisted: row.assisted === true }
    : { isBodyweight: storedKind === "bodyweight", isAssisted: false };
